(function(){
  function initAnn(root){
    var m=root.querySelectorAll('.rg-ann__msg'); if(m.length<2) return; var i=0;
    function go(n){i=(n+m.length)%m.length;m.forEach(function(e,j){e.classList.toggle('is-on',j===i)})}
    root.querySelector('.rg-ann__arw--p').onclick=function(){go(i-1)};
    root.querySelector('.rg-ann__arw--n').onclick=function(){go(i+1)};
    setInterval(function(){go(i+1)},4000);
  }
  function initSlides(root){
    var t=root.querySelector('.rg-slides__track'); if(!t) return; var n=t.children.length; var i=0;
    var dots=root.querySelectorAll('.rg-dots button');
    function go(k){i=(k+n)%n;t.style.transform='translateX(-'+(i*100)+'%)';dots.forEach(function(d,j){d.classList.toggle('is-on',j===i)})}
    var p=root.querySelector('.rg-arw--p'),q=root.querySelector('.rg-arw--n');
    if(p)p.onclick=function(){go(i-1)}; if(q)q.onclick=function(){go(i+1)};
    dots.forEach(function(d,j){d.onclick=function(){go(j)}});
    if(n>1) setInterval(function(){go(i+1)},5000);
  }
  function initCar(root){
    var t=root.querySelector('.rg-car__track'); if(!t) return;
    root.querySelectorAll('.rg-arw').forEach(function(b){b.onclick=function(){
      var d=b.classList.contains('rg-arw--p')?-1:1; t.scrollBy({left:d*t.clientWidth,behavior:'smooth'});
    }});
  }
  function initCards(root){
    root.querySelectorAll('[data-rg-open]').forEach(function(b){b.onclick=function(e){e.preventDefault();b.closest('.rg-card').querySelector('.rg-sizes').classList.add('is-open')}});
    root.querySelectorAll('[data-rg-close]').forEach(function(b){b.onclick=function(e){e.preventDefault();b.closest('.rg-sizes').classList.remove('is-open')}});
  }
  function initHead(root){
    var b=root.querySelector('.rg-burger'),nav=root.querySelector('.rg-mnav');
    if(!b||!nav) return;
    function close(){nav.classList.remove('is-open');nav.setAttribute('aria-hidden','true');b.setAttribute('aria-expanded','false');document.body.style.overflow='';b.focus()}
    b.onclick=function(){nav.classList.add('is-open');nav.setAttribute('aria-hidden','false');b.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';var first=nav.querySelector('a');if(first)first.focus()};
    nav.addEventListener('click',function(e){if(e.target===nav||e.target.closest('.rg-mnav__close'))close()});
    document.addEventListener('keydown',function(e){if(!nav.classList.contains('is-open'))return;if(e.key==='Escape')close();if(e.key==='Tab'){var links=nav.querySelectorAll('a,button');var first=links[0],last=links[links.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
  }
  function initClock(root){
    if(root.dataset.clockReady||!window.RangelleRules)return;
    root.dataset.clockReady='true';
    function tick(){
      var total=window.RangelleRules.remainingSeconds(Date.now());
      var values=[Math.floor(total/3600),Math.floor(total%3600/60),total%60];
      ['hours','minutes','seconds'].forEach(function(key,i){var el=root.querySelector('[data-'+key+']');if(el)el.textContent=String(values[i]).padStart(2,'0')});
    }
    tick();var interval=setInterval(function(){if(!root.isConnected){clearInterval(interval);return}tick()},1000);
  }
  function initCol(root){
    initInfinite(root);
    var lay=root.querySelector('.rg-col__lay'), form=root.querySelector('form.rg-fil-form'); if(!lay) return;
    var h=root.querySelector('[data-rg-hide]');
    if(h) h.onclick=function(){
      if(window.innerWidth<=990){lay.classList.remove('is-hide');lay.classList.add('is-mopen');return}
      lay.classList.toggle('is-hide'); h.querySelector('span').textContent=lay.classList.contains('is-hide')?'Show Filters':'Hide Filters';
    };
    var mc=root.querySelector('.rg-fil__mclose button'); if(mc) mc.onclick=function(){lay.classList.remove('is-mopen')};
    root.querySelectorAll('.rg-showmore').forEach(function(b){b.onclick=function(){var u=b.previousElementSibling;u.classList.toggle('is-all');b.textContent=u.classList.contains('is-all')?'Show Less':'Show More'}});
    if(form){
      form.querySelectorAll('input[type=checkbox]').forEach(function(c){c.addEventListener('change',function(){form.submit()})});
      var s=root.querySelector('select[name=sort_by]'); if(s) s.addEventListener('change',function(){
        var hid=form.querySelector('input[name=sort_by]'); hid.value=s.value; form.submit();});
    }
  }
  function initCart(root){
    root.querySelectorAll('.rg-qty').forEach(function(q){
      var i=q.querySelector('input'); q.querySelectorAll('button').forEach(function(b){b.onclick=function(e){e.preventDefault();
        var v=parseInt(i.value||0,10)+(b.dataset.d==='1'?1:-1); i.value=Math.max(0,v); i.form.submit();}});
      i.addEventListener('change',function(){i.form.submit()});
    });
  }
  function initInfinite(root){
    var grid=root.querySelector('[data-rg-products]'),loader=root.querySelector('[data-rg-load]');
    if(!grid||!loader||loader.dataset.ready)return;
    loader.dataset.ready='1';
    var status=loader.querySelector('[data-rg-load-status]'),next=loader.querySelector('[data-rg-next]'),busy=false,observer;
    if(!next)return;
    function watch(){if(observer&&next)observer.observe(loader)}
    async function load(e){
      if(e)e.preventDefault();
      if(busy||!next)return;
      busy=true;loader.classList.remove('is-error');grid.setAttribute('aria-busy','true');
      if(observer)observer.unobserve(loader);
      status.textContent='Loading products…';
      try{
        var url=new URL(next.href,location.href);
        if(url.origin!==location.origin)throw new Error('Invalid collection URL');
        var response=await fetch(url.href);
        if(!response.ok)throw new Error('Collection request failed');
        var html=await response.text();
        // Static preview documents generate their demo rows in a script; Shopify sends ready-made cards.
        var doc=new DOMParser().parseFromString(html,'text/html');
        var incoming=doc.querySelector('[data-rg-products]');
        if(incoming&&!incoming.children.length&&window.RangelleRules&&typeof PRODUCTS!=='undefined'){
          var selected=window.RangelleRules.collections.find(function(c){return c.handle===root.dataset.rgCollection});
          if(selected){
            var page=Number(url.searchParams.get('page'))||1;
            incoming.innerHTML=window.RangelleRules.collectionItems(PRODUCTS,selected,page,20).map(card).join('');
            var previewNext=doc.querySelector('[data-rg-next]');
            if(previewNext){if(page*20<selected.count){url.searchParams.set('page',page+1);previewNext.href=url.href}else previewNext.remove()}
          }
        }
        if(!incoming||!incoming.children.length)throw new Error('Missing collection products');
        var fragment=document.createDocumentFragment();
        Array.from(incoming.children).forEach(function(item){initCards(item);fragment.appendChild(item)});
        grid.appendChild(fragment);
        var following=doc.querySelector('[data-rg-next]');
        if(following){
          var followingUrl=new URL(following.getAttribute('href'),response.url||url.href);
          if(followingUrl.href===next.href)throw new Error('Repeated collection page');
          next.href=followingUrl.href;status.textContent='';
        }else{next.remove();next=null;status.textContent='All products loaded';if(observer)observer.disconnect()}
      }catch(error){loader.classList.add('is-error');status.textContent='Products could not load. Please try again.';if(next)next.textContent='Retry'}
      finally{busy=false;grid.setAttribute('aria-busy','false');if(!loader.classList.contains('is-error'))watch()}
    }
    next.addEventListener('click',load);
    if('IntersectionObserver' in window){
      loader.classList.add('is-auto');
      observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting}))load()},{rootMargin:'0px 0px 400px 0px'});
      watch();
    }
  }
  function refreshCount(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('.rg-count').forEach(function(e){e.textContent=c.item_count;e.dataset.count=c.item_count});
    }).catch(function(){});
  }
  document.addEventListener('cart:update',refreshCount);
  function initAll(scope){
    scope.querySelectorAll('[data-rg-clock]').forEach(initClock);
    scope.querySelectorAll('.rg-ann').forEach(initAnn);
    scope.querySelectorAll('.rg-slides').forEach(initSlides);
    scope.querySelectorAll('.rg-car').forEach(initCar);
    scope.querySelectorAll('.rg-head').forEach(initHead);
    scope.querySelectorAll('.rg-col').forEach(initCol);
    scope.querySelectorAll('.rg-cart').forEach(initCart);
    initCards(scope);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initAll(document)}); else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();
(function(){
  function initPdp(root){
    if(root.dataset.pdpReady)return;root.dataset.pdpReady='1';
    var main=root.querySelector('.rg-gal__main img');
    root.querySelectorAll('.rg-gal__th button').forEach(function(b){b.onclick=function(){main.removeAttribute("srcset");main.removeAttribute("sizes");main.src=b.dataset.src;root.querySelectorAll('.rg-gal__th button').forEach(function(x){x.classList.toggle('is-on',x===b)})}});
    root.querySelectorAll('[data-rg-chart]').forEach(function(a){a.onclick=function(e){e.preventDefault();root.querySelector('.rg-modal').classList.add('is-open')}});
    var m=root.querySelector('.rg-modal');if(m)m.addEventListener('click',function(e){if(e.target===m||e.target.closest('.rg-modal__x'))m.classList.remove('is-open')});
    var form=root.querySelector('form.rg-pdp__form'),vjson=root.querySelector('[data-rg-variants]');
    if(form&&vjson){
      var variants=JSON.parse(vjson.textContent),idIn=form.querySelector('input[name=id]');
      var price=root.querySelector('[data-rg-price]'),cmp=root.querySelector('[data-rg-compare]'),off=root.querySelector('[data-rg-off]');
      var fmt=function(c){return 'Rs. '+Math.round(c/100).toLocaleString('en-IN')};
      function sync(){
        var sel=[].map.call(form.querySelectorAll('.rg-opt'),function(g){var c=g.querySelector('input:checked');return c?c.value:null});
        var v=variants.find(function(v){return v.options.every(function(o,i){return o===sel[i]})});
        root.querySelectorAll('[data-rg-atc]').forEach(function(b){b.disabled=!v||!v.available;b.textContent=!v?'Unavailable':(v.available?b.dataset.label:'Sold out')});
        if(!v)return;idIn.value=v.id;price.textContent=fmt(v.price);
        if(v.compare_at_price>v.price){cmp.textContent=fmt(v.compare_at_price);off.textContent=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'% OFF'}else{cmp.textContent='';off.textContent=''}
        var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
      }
      form.addEventListener('change',sync);sync();
    }
    root.querySelectorAll('[data-rg-buynow]').forEach(function(b){b.addEventListener('click',function(){var r=form&&form.querySelector('input[name=return_to]');if(r)r.value='/checkout'})});
    var pin=root.querySelector('.rg-pin form');if(pin)pin.onsubmit=function(e){e.preventDefault();var v=pin.querySelector('input').value.trim();pin.parentNode.querySelector('small').textContent=/^\d{6}$/.test(v)?'✓ Delivery in 4-7 days to '+v:'Sahi 6-digit pincode daalein'};
    root.querySelectorAll('[data-rg-sizes] button').forEach(function(b){b.onclick=function(e){e.preventDefault();b.parentNode.querySelectorAll('button').forEach(function(x){x.classList.toggle('is-on',x===b)})}});
  }
  function run(s){s.querySelectorAll('.rg-pdp').forEach(initPdp)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){run(document)});else run(document);
  document.addEventListener('shopify:section:load',function(e){run(e.target)});
})();
